<div class="mapping-header-main">
    <p class="mapping-header-heading">
        {{entityName}}
    </p>
    
</div>
